import UpdateItem from "./UpdateItem";

export default class UpdateOrder {
	id: string;
	customerName: string;
	customerPhoneNumber: string;
	deliveryDate: Date;
	items: Array<UpdateItem>;

	constructor() {
		this.items = new Array<UpdateItem>();
	}
}
